import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/style.css"

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [activeLang, setActiveLang] = useState('hy'); // язык по умолчанию

  // При загрузке компонента берем язык из localStorage
  useEffect(() => {
    const savedLang = localStorage.getItem('i18nextLng') || 'hy';
    setActiveLang(savedLang);
    i18n.changeLanguage(savedLang);
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setActiveLang(lng);
    localStorage.setItem('i18nextLng', lng); // сохраняем выбор
  };

  return (
    <div className='langBtns'>
      <button 
        onClick={() => changeLanguage('hy')} 
        className={activeLang === 'hy' ? 'active' : ''}
      >
        Հայ
      </button>
      <button 
        onClick={() => changeLanguage('ru')} 
        className={activeLang === 'ru' ? 'active' : ''}
      >
        Рус
      </button>
      <button 
        onClick={() => changeLanguage('en')} 
        className={activeLang === 'en' ? 'active' : ''}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;

